import { History } from 'history';
import queryString from 'query-string';
import filter from 'lodash/filter';
import values from 'lodash/values';

type UrlParams = {
  playlist?: string;
  'playlist-item'?: string;
};

export const arePlaylistUrlParamsEqual = (
  params1: UrlParams,
  params2: UrlParams,
) =>
  params1['playlist-item'] == params2['playlist-item'] &&
  params1.playlist == params2.playlist;

export const updatePlaylistUrl = (
  history: History,
  playlistId?: string,
  playlistItemId?: string,
  silent: boolean = false,
) => {
  const originalParams = queryString.parse(location.search) || {};
  const newParams: UrlParams = {
    playlist: playlistId,
    'playlist-item': playlistItemId,
  };

  if (arePlaylistUrlParamsEqual(originalParams, newParams)) {
    return;
  }

  const newQueryString = queryString.stringify(newParams);
  const isNewQueryStringEmpty =
    filter(values(newParams), (el) => el !== null).length === 0;
  const newUrl =
    location.pathname + (isNewQueryStringEmpty ? '' : `?${newQueryString}`);

  /**
   * We want following behaviour:
   *   user clicks to open player ->
   *   users clicks to next artwrok ->
   *   user clicks back in browser ->
   *   player is closed (we don't want it to go back to previous artwork).
   *
   * That's why we check if playlist-item exited, if it did, we replace state.
   */
  if (originalParams['playlist-item'] && newParams['playlist-item']) {
    history.replace(newUrl, { silent });
  } else {
    history.push(newUrl, { silent });
  }
};
